module.exports = __webpack_public_path__ + "fonts/Montserrat-LightItalic.57ae456.ttf";